module.exports = __webpack_public_path__ + "static/media/calendar.17ac1d91.svg";